import { Transform } from 'class-transformer';
import { UserFilter } from './user.filter';
import { stringToBooleanNullable } from '../../types-transformers/boolean-transformers';
import { stringToInt } from '../../types-transformers/number-transformers';

export class SweatMatchFilter extends UserFilter {
	@Transform(stringToBooleanNullable)
	public onlyReadyToSweatMatch?: boolean;

	@Transform(stringToBooleanNullable)
	public onlyNotReadyToSweatMatch?: boolean;

	@Transform(stringToInt)
	public limit?: number;
}
